import { Container, Graphics, Sprite, useApp } from "@pixi/react";
import { useEffect, useRef, useState } from "react";
import { gameModuleService } from "../../services/gameModuleService";
import { Texture } from "pixi.js";
import WinLine from "../winLine";
import { observer } from "mobx-react-lite";
import { gameConfigurationStore } from "../../store/gameConfigurationStore";
import { GameWinBoard } from "../winBoardContainer";


export const ReelContainer = observer(() => {
    const { ticker } = useApp();
    const reelContainerRef = useRef();
    const winContainerRef = useRef();
    const gameBoardContainerRef = useRef(null);

    const touchSpinScreenRef = useRef();
    const { symbolsSizes, reelsContainerParams } = gameConfigurationStore
    const [mask, setMask] = useState(null);
    const reelContainerConfig = {
        x: reelsContainerParams.xInFigma + symbolsSizes.width / 2,
        y: reelsContainerParams.yInFigma + symbolsSizes.height / 2,
        width: reelsContainerParams.width,
        height: reelsContainerParams.height,
    }
    const touchSpinScreenConfig = {
        x: reelsContainerParams.xInFigma,
        y: reelsContainerParams.yInFigma,
        width: reelsContainerParams.width,
        height: reelsContainerParams.height,
    }
    useEffect(() => {
        if (reelContainerRef.current) {
            reelContainerRef.current.mask = mask;
        }
    }, [mask, reelContainerRef]);
    useEffect(() => {
        gameModuleService.createReels(
            reelContainerRef.current,
            winContainerRef.current,
            touchSpinScreenRef.current,
            gameBoardContainerRef.current,
            ticker,
        );

    }, [ticker]);
    return <>
        <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
            <Graphics
                draw={(g) => {
                    g.beginFill(0xff700b);
                    g.drawRect(
                        -symbolsSizes.width / 2 + reelsContainerParams.offsetForContainerBoardWidth,
                        -symbolsSizes.height / 2 + reelsContainerParams.offsetForContainerBoardHeight,
                        reelsContainerParams.width - (reelsContainerParams.offsetForContainerBoardWidth * 3),
                        reelsContainerParams.height - (reelsContainerParams.offsetForContainerBoardHeight * 3),
                    );
                }}
                ref={(graphicsRef) => setMask(graphicsRef)}
            />
        </Container>
        <WinLine />
        <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
        <GameWinBoard />
        <Container ref={gameBoardContainerRef} {...reelContainerConfig} name='WinFrameContainer' />
        <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
            <Sprite
                texture={Texture.EMPTY}
                width={reelContainerConfig.width}
                height={reelContainerConfig.height}
            />
        </Container>
    </>
})